export default theme => ({
  footer: {
    background: '#222',
    color: '#fff',
    textAlign: 'center',
    padding: 4,
    marginTop: 15,
    fontSize: 13,
  }
});